module.exports = __webpack_public_path__ + "static/media/03-grid.c6e8b7d4.png";